import { defineStore } from 'pinia'
/**
 * 現在のページの状態を管理するためのStateStore
 */
export const usePageStore = defineStore('page', () => {
  const _current = ref<Page | null>(null)

  const setCurrentPage = (page: Page) => {
    _current.value = page
  }

  const current = computed(() => _current.value)

  return {
    setCurrentPage,
    current,
  }
})
